import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Comentarios from "./Comentarios";

const API_BASE = "https://suadesarrollo.azurewebsites.net/api";

const axiosInstance = axios.create({
  auth: {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  },
});

function InforEncuestas() {
  const { tipo, idSolicitud } = useParams();

  const [conteo, setConteo] = useState(0);
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  /* =========================
     CARGA DE DATOS
  ========================== */
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(false);

        const [conteoRes, resultadosRes] = await Promise.all([
          axiosInstance.get(
            `${API_BASE}/ObtenerConteoEvaluaciones/${tipo}/${idSolicitud}`,
          ),
          axiosInstance.get(
            `${API_BASE}/ObtenerResultados/${tipo}/${idSolicitud}`,
          ),
        ]);

        setConteo(conteoRes.data);
        setResultados(
          Array.isArray(resultadosRes.data) ? resultadosRes.data.flat() : [],
        );
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [tipo, idSolicitud]);

  /* =========================
     FILTROS OPTIMIZADOS
  ========================== */
  const filtroAbierta = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Abierta"),
    [resultados],
  );

  const filtroSeleccion = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Seleccion"),
    [resultados],
  );

  const filtroCalificacion = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Calificacion"),
    [resultados],
  );

  /* =========================
     RENDER
  ========================== */
  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" />
        <p className="mt-2">Cargando información de encuestas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center mt-4">
        Error cargando la información de las encuestas
      </div>
    );
  }
  const filtroSeleccionUnico = filtroSeleccion.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.preguntas === item.preguntas),
  );

  const filtroCalificacionUnico = filtroCalificacion.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.pregunta === item.pregunta),
  );

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Información Encuestas
          </h6>
          {tipo == 1 && <div>Usuarios</div>}
          {tipo == 2 && <div>Trabajadores</div>}
          {tipo == 3 && <div>Paciente Trazador</div>}
          <div>Encuestas realizadas: {conteo}</div>
        </div>

        <div className="card-body table-responsive">
          {/* =========================
              TIPO 3 – PACIENTE
          ========================== */}
          {tipo == 3 && (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Variable</th>
                  <th>% Cumplimiento</th>
                </tr>
              </thead>
              <tbody>
                {resultados.map(({ pregunta, suma, respuestasEfectivas }) => {
                  const porcentaje = (
                    (suma / respuestasEfectivas / 5) *
                    100
                  ).toFixed(0);

                  return (
                    <tr key={pregunta}>
                      <td>{pregunta}</td>
                      <td className={porcentaje <= 75 ? "bg-warning" : ""}>
                        {porcentaje}%
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          {/* =========================
              TIPO 2 – TRABAJADORES
          ========================== */}
          {tipo == 2 && (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Variable</th>
                    <th>Completa</th>
                    <th>%DE TRABAJADORES CON RESPUESTA CORRECTA</th>
                    <th>Incorrecta</th>
                    <th>%DE TRABAJADORES CON RESPUESTA INCORRECTA</th>
                    <th>Parcial</th>
                    <th>%DE TRABAJADORES CON RESPUESTA PARCIAL</th>
                  </tr>
                </thead>
                <tbody>
                  {filtroAbierta.map((item) => {
                    const p = (v) => ((v / conteo) * 100).toFixed(0);
                    return (
                      <tr key={item.pregunta}>
                        <td>{item.pregunta}</td>
                        <td>{item.completa}</td>
                        <td
                          className={p(item.completa) <= 75 ? "bg-warning" : ""}
                        >
                          {p(item.completa)}%
                        </td>
                        <td>{item.incompleta}</td>
                        <td
                          className={
                            p(item.incompleta) <= 75 ? "bg-warning" : ""
                          }
                        >
                          {p(item.incompleta)}%
                        </td>
                        <td>{item.parcial}</td>
                        <td
                          className={p(item.parcial) <= 75 ? "bg-warning" : ""}
                        >
                          {p(item.parcial)}%
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Variable</th>
                    <th>Si</th>
                    <th>% DE TRABAJADORES SI</th>
                    <th>No</th>
                    <th>% DE TRABAJADORES NO</th>
                  </tr>
                </thead>
                <tbody>
                  {filtroSeleccionUnico.map((item) => (
                    <tr key={item.pregunta}>
                      <td>{item.pregunta}</td>
                      <td>{item.afirmativo}</td>
                      <td>{((item.afirmativo / conteo) * 100).toFixed(0)}%</td>
                      <td>{item.negativo}</td>
                      <td>{((item.negativo / conteo) * 100).toFixed(0)}%</td>
                      <td>{item.noaplica}</td>
                      <td>{((item.noaplica / conteo) * 100).toFixed(0)}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {/* =========================
              TIPO 1 – USUARIOS
          ========================== */}
          {tipo == 1 && (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Variable</th>
                    <th>Si</th>
                    <th>Si %</th>
                    <th>No</th>
                    <th>No %</th>
                    <th>No Aplica</th>
                    <th>Na %</th>
                  </tr>
                </thead>
                <tbody>
                  {filtroSeleccion.map((item) => (
                    <tr key={item.pregunta}>
                      <td>{item.pregunta}</td>
                      <td>{item.afirmativo}</td>
                      <td>{((item.afirmativo / conteo) * 100).toFixed(0)}%</td>
                      <td>{item.negativo}</td>
                      <td>{((item.negativo / conteo) * 100).toFixed(0)}%</td>
                      <td>{item.noAplica}</td>
                      <td>{((item.noAplica / conteo) * 100).toFixed(0)}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Variable</th>
                    <th>Muy mala</th>
                    <th>Mala</th>
                    <th>Regular</th>
                    <th>Buena</th>
                    <th>Muy Buena</th>
                    <th>Excelente</th>
                    <th>NA</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {filtroCalificacionUnico.map((item) => {
                    const total =
                      ((item.muyMala +
                        item.mala +
                        item.regular +
                        item.buena +
                        item.muyBuena +
                        item.excelente) /
                        conteo) *
                      100;

                    return (
                      <tr key={item.pregunta}>
                        <td>{item.pregunta}</td>
                        <td>{item.muymala}</td>
                        <td>{item.mala}</td>
                        <td>{item.regular}</td>
                        <td>{item.buena}</td>
                        <td>{item.muyBuena}</td>
                        <td>{item.excelente}</td>
                        <td>{item.na}</td>
                        <td>{total.toFixed(0)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}

          <Comentarios tipo={tipo} idSolicitud={idSolicitud} />
        </div>
      </div>
    </div>
  );
}

export default InforEncuestas;
